var __jsx = React.createElement;
import { styled } from '@linaria/react';
import { Pocket, useWaffles } from '@pelotoncycle/waffles';
import React from 'react';
import { MediumButton } from '@webtv/buttons';
import { useCopy } from '@webtv/copy-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AppExitConfirmationModal = function AppExitConfirmationModal(_ref) {
  var handleResume = _ref.handleResume;

  var _useWaffles = useWaffles(),
      createFocusTrap = _useWaffles.createFocusTrap;

  var focusRoot = React.useRef();
  var resumeRef = React.useRef();
  var resumeFocusRef = React.useRef();
  var exitFocusRef = React.useRef();
  var headerCopy = useCopy('global.exitConfirmationHeader');
  var cancelCopy = useCopy('global.exitConfirmationCancel');
  var confirmCopy = useCopy('global.exitConfirmationConfirm');
  React.useEffect(function () {
    if (focusRoot !== null && focusRoot !== void 0 && focusRoot.current) {
      var _resumeRef$current;

      createFocusTrap(focusRoot === null || focusRoot === void 0 ? void 0 : focusRoot.current, (_resumeRef$current = resumeRef === null || resumeRef === void 0 ? void 0 : resumeRef.current) !== null && _resumeRef$current !== void 0 ? _resumeRef$current : undefined);
    }
  }, [createFocusTrap]);
  return /*#__PURE__*/_jsx(Pocket, {
    id: "browse-exit-modal",
    ref: focusRoot,
    position: 3,
    children: /*#__PURE__*/_jsxs(ExitModal, {
      role: "dialog",
      "data-test-id": "exitConfirmation",
      children: [/*#__PURE__*/_jsx(Header, {
        children: headerCopy
      }), /*#__PURE__*/_jsx(ButtonWrapper, {
        children: /*#__PURE__*/_jsxs(Pocket, {
          horizontal: true,
          id: "ExitAppConfirmation",
          children: [/*#__PURE__*/_jsx(Pocket, {
            position: 0,
            id: "Resume",
            ref: resumeRef,
            focusRef: resumeFocusRef,
            children: /*#__PURE__*/_jsx(MediumButton, {
              focusRef: resumeFocusRef,
              handleClick: function handleClick() {
                handleResume();
              },
              dataTestId: "resumeButton",
              ariaLabel: "".concat(headerCopy, " ").concat(cancelCopy),
              children: cancelCopy
            })
          }), /*#__PURE__*/_jsx(Pocket, {
            position: 1,
            id: "Exit",
            focusRef: exitFocusRef,
            children: /*#__PURE__*/_jsx(MediumButton, {
              focusRef: exitFocusRef,
              handleClick: function handleClick() {
                window.close();
              },
              ariaLabel: confirmCopy,
              children: confirmCopy
            })
          })]
        })
      })]
    })
  });
};
var ExitModal = /*#__PURE__*/styled("div")({
  name: "ExitModal",
  class: "epvlwq6"
});
var ButtonWrapper = /*#__PURE__*/styled("div")({
  name: "ButtonWrapper",
  class: "b11g54l6"
});
var Header = /*#__PURE__*/styled("h1")({
  name: "Header",
  class: "h1e4nnoh"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/shared-ui/AppExitConfirmationModal.linaria.module.css");